import type { ValueHandler } from '@broker-as/acquisit-ui-vue/library'

export const handleElhubController: ValueHandler = async ({
	component,
	value,
	invalidateAll,
	invalidators,
	setProperties
}): Promise<void> => {
	// Point is to avoid invalidations when internal status changes. Only on retry do we reset.
	if (value === null) {
		invalidateAll()
	} else if (value?.status === 'error') {
		// Only invalidate dependent pages like signature
		if (invalidators.dependentPages) {
			invalidators.dependentPages({
				component
			})
		}
	}
	
	setProperties(component, {
		modelValue: value
	})
}